module.exports = __webpack_public_path__ + "img/icon-marker-accent-9.5a271da7.svg";